import { setCookie, getCookie } from '../../mixins/cookie';
import { messagePopup, displayMessagePopup } from '../../mixins/snackbar';

const restNamespace = WCBT_GLOBAL_OBJECT.rest_namespace || '';
const userId = WCBT_GLOBAL_OBJECT.user_id || '';
const { __ } = wp.i18n;
const addWishListTooltipText = WCBT_WISHLIST_OBJECT.add_wishlist_tooltip_text || '';
const removeWishListTooltipText = WCBT_WISHLIST_OBJECT.remove_wishlist_tooltip_text || '';

const wcbtToggleWishList = () => {
	const wishlistNode = document.querySelector( '#wcbt-wishlist' );
	document.addEventListener( 'click', function( event ) {
		//If is wishlist page, return
		if ( wishlistNode && wishlistNode.contains( event.target ) ) {
			return;
		}

		const wishListNodes = document.querySelectorAll( '.wcbt-product-wishlist' );
		for ( let i = 0; i < wishListNodes.length; i++ ) {
			const wishListNode = wishListNodes[ i ];
			if ( wishListNode.contains( event.target ) ) {
				event.preventDefault();
				let productId = wishListNode.getAttribute( 'data-product-id' );
				productId = parseInt( productId );
				wishListNode.disabled = true;
				if ( userId ) {
					const data = { product_id: productId };
					wp.apiFetch( {
						path: '/' + restNamespace + '/wishlist', method: 'POST', data,
					} ).then( ( res ) => {
						if ( res.data.status === 'added' ) {
							wishListNode.classList.add( 'active' );
							messagePopup.innerHTML = __( 'Product WishList added', 'wcbt' );
						} else {
							wishListNode.classList.remove( 'active' );
							messagePopup.innerHTML = __( 'Product WishList removed', 'wcbt' );
						}

						displayMessagePopup();
						updateTotal( res.data.total );
					} ).catch( ( err ) => {
						console.log( err );
					} ).finally( () => {
						wishListNode.disabled = false;
						wishListTooltip( wishListNode );
					} );
				} else {
					let productIds = getWishListCookie();
					if ( ! productIds ) {
						productIds = [];
					}
					//Remove wishlist product
					if ( productIds.includes( productId ) ) {
						productIds = productIds.filter( ( item ) => item !== productId );
						messagePopup.innerHTML = __( 'Product WishList removed', 'wcbt' );
						wishListNode.classList.remove( 'active' );
					} else {
						productIds.push( productId );
						messagePopup.innerHTML = __( 'Product WishList added', 'wcbt' );
						wishListNode.classList.add( 'active' );
					}

					setCookie( 'wcbt_wishlist_product', productIds.join( ',' ), 30 );
					displayMessagePopup();
					updateTotal( productIds.length );
					wishListNode.disabled = false;
					wishListTooltip( wishListNode );
				}
			}
		}
	} );

	displayActiveWishList();
	displayWishListCount();
};

//Fix for cache page
const displayActiveWishList = () => {
	if ( userId ) {
		return;
	}

	const wishList = getWishListCookie();

	if ( ! wishList ) {
		return;
	}

	const wishListBtnNodes = document.querySelectorAll( '.wcbt-product-wishlist' );

	[ ...wishListBtnNodes ].map( ( wishListBtn ) => {
		const productId = parseInt( wishListBtn.getAttribute( 'data-product-id' ) );

		if ( wishList.includes( productId ) ) {
			wishListBtn.classList.add( 'active' );
		} else {
			wishListBtn.classList.remove( 'active' );
		}
	} );
};

//Fix for cache page
const displayWishListCount = () => {
	if ( userId ) {
		return;
	}

	const wishList = getWishListCookie();

	let count = 0;
	if ( wishList ) {
		count = wishList.length;
	}

	const countNodes = document.querySelectorAll( '.wcbt-show-wishlist .count' );

	[ ...countNodes ].map( ( countNode ) => {
		countNode.innerHTML = count;
	} );
};

const getWishListCookie = () => {
	const productIds = getCookie( 'wcbt_wishlist_product' );
	if ( productIds === null || ! productIds ) {
		return [];
	}

	return productIds.split( ',' ).map( Number );
};

const updateTotal = ( total ) => {
	const wishlistCountNodes = document.querySelectorAll( '.wcbt-show-wishlist .count' );

	[ ...wishlistCountNodes ].map( ( wishlistCountNode ) => {
		wishlistCountNode.innerHTML = total;
	} );
};

const wishListTooltip = ( productWishlistNode ) => {
	const tooltipNode = productWishlistNode.querySelector( 'span.tooltip' );
	if ( ! tooltipNode ) {
		return;
	}
	if ( productWishlistNode.classList.contains( 'active' ) ) {
		tooltipNode.innerHTML = removeWishListTooltipText;
	} else {
		tooltipNode.innerHTML = addWishListTooltipText;
	}
};

export { getWishListCookie, updateTotal };
export default wcbtToggleWishList;
